/* tslint:disable */
/* eslint-disable */
export enum WorkChangelogResolvedByEnum {
  Local = 'LOCAL',
  External = 'EXTERNAL'
}
